export default class SearchJwtServices {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  autocomplete(search_type, params) {
    return this.axiosIns.get(`${this.jwtConfig.main.searchEndpoint}/${search_type}/autocomplete`, {
      params
    })
  }
}
